import { Box } from '@mui/material';
import type { FC } from 'react';
import Illustration4 from '~/assets/svgs/illustration-4.svg';

export const ReportsBanner: FC = () => {
  return (
    <Box component="section" position="relative" bgcolor="#F9FAFB" height={{ xs: 90, md: 132 }}>
      <Box
        component="img"
        src={Illustration4}
        alt="Reports"
        width={{ xs: 144, md: 188 }}
        height={{ xs: 64, md: 96 }}
        position="absolute"
        bottom={0}
        left="50%"
        sx={{ transform: { xs: 'translate(-50%, 20px)', md: 'translate(-50%, 14px)' } }}
      />
    </Box>
  );
};
